<template>
    <div class="selected d-flex justify-content-start align-items-center" v-if="forecastsAvailableXls.length > 1">
        <div class="title"><p>Selected :</p></div>
        <template>
            <ForecastMultiXlsIcon @click="downloadXls()"></ForecastMultiXlsIcon>
        </template>
    </div>
</template>
<script>
import { FORECAST_STATUS, FORECAST_WINDOW_STATUS } from "@/components/forecasts/constants";
import TryLoad from "@/mixins/TryLoadMixin";
import ForecastStatus from "@/components/forecasts/elements/ForecastStatus";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import ForecastMultiXlsIcon from "@/components/forecasts/elements/icons/ForecastMultiXlsIcon";
import forecastsService from "@/components/forecasts/forecastsService";
import Globals from "@/components/globals";
import { mapGetters } from "vuex";

export default {
    components: {
        ForecastMultiXlsIcon,
        ForecastStatus
    },
    props: {
        forecasts: {
            type: Array
        }
    },
    data() {
        return {
            PROFILES
        };
    },
    mixins: [TryLoad],
    computed: {
        ...mapGetters("brand", { campaigns: "getCampaigns" }),
        ...mapGetters({ getBrand: "brand/getBrand" }),
        forecastsAvailableXls() {
            if (this.forecasts != null) {
                return this.forecasts.filter(f => this.isXlsExist(f));
            }
            return [];
        }
    },
    methods: {
        isXlsExist(forecast) {
            return !!(
                forecast.status !== FORECAST_STATUS.DRAFT &&
                forecast.status !== FORECAST_STATUS.PENDING &&
                forecast.deleted !== true &&
                this.hasAtLeastOneSubmission(forecast)
            );
        },
        hasAtLeastOneSubmission(forecast) {
            return forecast.forecastWindows.some(fw => fw.status === FORECAST_WINDOW_STATUS.SUBMITTED);
        },
        async downloadXls() {
            this.$emit("updateLoading", true);
            const ids = this.forecasts.map(f => f.id);
            const resp = await this.tryLoad(() => forecastsService.getPathForExportXLS(ids));
            const a = document.createElement("a");
            a.href = URL.createObjectURL(new Blob([resp], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
            a.setAttribute("download", "Forecast-" + this.getBrand.name + "-" + Globals.moment(new Date()).format("YYYYmmDD HHmmss") + ".xlsx");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            this.$emit("updateLoading", false);
        }
    }
};
</script>
<style scoped lang="scss">
.title {
    margin-right: 10px;
    padding: 0 5px;
    p {
        font-weight: 400;
        font-size: 18px;
        font-family: Oswald, Sans-Serif;
        padding: 0;
        margin: 0;
        color: black;
        text-transform: uppercase;
    }
}
.selected {
    transition: 0.3s ease-in-out;
    background-color: #f1f1f2;
    padding: 3px 0;
    margin: 5px 0;
    min-height: 45px;
}
</style>



// WEBPACK FOOTER //
// ForecastMultiSelected.vue?55f3bae0